module.exports = __webpack_public_path__ + "static/media/logo-beer.a8213f6b.jpg";